import React from 'react';
import { loadOrg, updateOrg, logout} from "./../../actions/actions";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
import Button from  '@material-ui/core/Button'
import { Redirect } from  "react-router-dom";
import Header from './../Header';
import Footer from './../Footer';
import { withStyles} from '@material-ui/core/styles';
import { styles } from './../../helpers/classes';
import { org_attr } from './../../helpers/trans';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import { DatePicker } from 'material-ui-pickers';
import moment from 'moment';
import 'moment/locale/ru';
import OldBrowserMessage from './../OldBrowserMessage';

export class OrgProfile extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            redirect: null,
            user: {},
            auth: false,
            org_form: {
                website:'',
                email:'',
                org_name:'',
                country:'',
                street:'',
                state:'',
                region:'',
                city:'',
                tax_company_name:'',
                phones:'',
                certificate_date:'',
                certificate_number:''
            }
        }
    }

    updateInput = input => {
        let data = {[input.name]: input.value};
        let currentData = this.state.org_form;
        this.setState({org_form: {...currentData, ...data}});
    };

    updateOrg = () => {
        this.props.updateOrg(this.state.user.token, this.state.org_form);
    };

    updateDateInput = name => date => {
        console.log(date);
        console.log(name);
        let value = date.toISOString().split('T')[0];
        let data = {[name]: value } ;
        let currentData = this.state.org_form;
        this.setState({org_form:{ ...currentData, ...data}});
    }
    
    componentWillMount() {
        let user = JSON.parse(localStorage.getItem('user'));
        if( user !== null ){
            if (user.role.indexOf('ROLE_BUILD_ORG')>=0 ||user.role.indexOf('ROLE_BUILD_USER')>=0) {
                this.setState({auth: true, user: user});
                this.props.loadOrg(user.token);
            }
        }
    }

    componentWillReceiveProps(nextProps){
        if ('org' in nextProps) {
            let org = nextProps.org;
            if (Array.isArray(nextProps.org.phones)){
                org.phones = nextProps.org.phones.join(", ")
            }

            this.setState({org_form: org});
        }
    }

    logout = () => {
        this.props.logout() ;
        this.setState({auth:false, redirect: null, user:{}});
    }

    render () {
        if (this.state.auth == false) {
            return (<Redirect to="/login"/>)
        }

        const {classes, org} = this.props;
        
        return (
            <Typography variant="div" >
                <Header link={{title: this.state.user.org, to:'/org-cabinet/'}}/>
                <Toolbar>
                <Button component={Link} to="/org-cabinet/">Вернуться</Button><Button onClick={this.logout}>Выйти</Button>
                </Toolbar>
                <OldBrowserMessage />
                <Typography variant="h4" className={classes.headerStatic} variant="headline" style={{marginLeft:'3em'}}> Профиль организации</Typography>
                <form style={{ paddingLeft:'4em', paddingRight:'4em', marginBottom:'6em' }}>
                    <TextField
                        className={classes.textField}
                        classes={{root: classes.rootFlex, filled:classes.newColor}}
                        required
                        onChange={e => this.updateInput(e.target)}
                        label={org_attr.website}
                        fullWidth
                        id="website"
                        name="website"
                        margin="normal"
                        value={this.state.org_form.website}
                        InputProps={{className: classes.input }}
                        InputLabelProps={{shrink: true, className: classes.label}}
                    />
                    <TextField
                        disabled
                        className={classes.textField}
                        classes={{root: classes.rootFlex, filled:classes.newColor}}
                        required
                        onChange={e => this.updateInput(e.target)}
                        label={org_attr.org_name}
                        fullWidth
                        id="org_name"
                        name="org_name"
                        margin="normal"
                        value={this.state.org_form.org_name}
                        InputProps={{className: classes.input }}
                        InputLabelProps={{shrink: true, className: classes.label}}
                    />
                    <TextField
                        className={classes.textField}
                        classes={{root: classes.rootFlex, filled:classes.newColor}}
                        required
                        onChange={e => this.updateInput(e.target)}
                        label={org_attr.email}
                        fullWidth
                        id="email"
                        name="email"
                        margin="normal"
                        value={this.state.org_form.email}
                        InputProps={{className: classes.input}}
                        InputLabelProps={{shrink: true, className: classes.label}}
                    />
                    <TextField
                        disabled
                        className={classes.textField}
                        classes={{root: classes.rootFlex, filled:classes.newColor}}
                        required
                        onChange={e => this.updateInput(e.target)}
                        label={org_attr.country}
                        fullWidth
                        id="country"
                        name="country"
                        margin="normal"
                        value={this.state.org_form.country}
                        InputProps={{className: classes.input}}
                        InputLabelProps={{shrink: true,className: classes.label}}
                    />
                    <TextField
                        className={classes.textField}
                        classes={{root: classes.rootFlex, filled:classes.newColor}}
                        required
                        onChange={e => this.updateInput(e.target)}
                        label={org_attr.state}
                        fullWidth
                        id="state"
                        name="state"
                        margin="normal"
                        value={this.state.org_form.state}
                        InputProps={{className: classes.input}}
                        InputLabelProps={{shrink: true,className: classes.label}}
                    />
                    <TextField
                        className={classes.textField}
                        classes={{root: classes.rootFlex, filled:classes.newColor}}
                        required
                        onChange={e => this.updateInput(e.target)}
                        label={org_attr.region}
                        fullWidth
                        id="region"
                        name="region"
                        value={this.state.org_form.region}
                        InputProps={{className: classes.input}}
                        InputLabelProps={{shrink: true,className: classes.label}}
                    />
                    <TextField
                        disabled
                        className={classes.textField}
                        classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                        required
                        onChange={e => this.updateInput(e.target)}
                        label={org_attr.city}
                        fullWidth
                        id="city" name="city"
                        margin="normal"
                        value={this.state.org_form.city}
                        InputProps={{  className: classes.input }}
                        InputLabelProps={{shrink: true, className: classes.label
                                      }}
                    />
                    <TextField
                        className={classes.textField}
                        classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                        required
                        onChange={e => this.updateInput(e.target)}
                        label={org_attr.street}
                        fullWidth
                        id="street"
                        name="street"
                        margin="normal"
                        value={this.state.org_form.street}
                        InputProps={{ className: classes.input }}
                        InputLabelProps={{shrink: true,className: classes.label}}
                    />
                    <TextField
                        className={classes.textField}
                        classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                        required
                        onChange={e => this.updateInput(e.target)}
                        label={org_attr.phone}
                        fullWidth
                        id="phone"
                        name="phones"
                        margin="normal"
                        value={this.state.org_form.phones}
                        InputProps={{className: classes.input}}
                        InputLabelProps={{shrink: true,className: classes.label}}
                    />
                    <TextField
                        className={classes.textField} classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                        required
                        onChange={e => this.updateInput(e.target)}
                        label={org_attr.tax_company_name}
                        fullWidth
                        id="tax_company_name"
                        name="tax_company_name"
                        value={this.state.org_form.tax_company_name}
                        InputProps={{  className: classes.input }}
                        InputLabelProps={{shrink: true,className: classes.label }}
                    />
                    <TextField
                        className={classes.textField} classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                        required
                        onChange={e => this.updateInput(e.target)}
                        label={org_attr.okpo}
                        fullWidth
                        id="okpo"
                        name="okpo"
                        value={this.state.org_form.okpo}
                        InputProps={{className: classes.input}}
                        InputLabelProps={{shrink: true,className: classes.label}}
                    />
                    <TextField
                        className={classes.textField}
                        classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                        required
                        onChange={e => this.updateInput(e.target)}
                        label={org_attr.unp}
                        fullWidth
                        id="unp"
                        name="unp"
                        disabled
                        margin="normal"
                        value={this.state.org_form.unp}
                        InputProps={{className: classes.input}}
                        InputLabelProps={{shrink: true,className: classes.label}}
                    />
                    <TextField
                        className={classes.textField}
                        classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                        required
                        onChange={e => this.updateInput(e.target)}
                        label={org_attr.certificate_number}
                        fullWidth id="certificate_number"
                        name="certificate_number" margin="normal"
                        value={this.state.org_form.certificate_number}
                        InputProps={{className: classes.input}}
                        InputLabelProps={{shrink: true,className: classes.label}}
                    />
                    <DatePicker
                        className={classes.textField} classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor}}
                        onChange={this.updateDateInput("certificate_date")}
                        label={org_attr.certificate_date}
                        fullWidth
                        format='DD.MM.YYYY'
                        id="certificate_date"
                        name="certificate_date"
                        value={this.state.org_form.certificate_date}
                        InputLabelProps={{ shrink: true, className: classes.label}}
                    />
                    <div className={classes.wrapperButton}>
                        <Button variant="contained" color="#76b5b8" size="large"
                                className={classes.button}
                                onClick={this.updateOrg}>
                            Обновить
                        </Button>
                    </div>
                </form>
                <Footer />
            </Typography>);
    }
}


    /* loadInspections, newNotification, signNotification, saveNotification, getNotification*/
function select(state, props) {
        const { user } = state;
        console.log('SELECT');
        console.log(user);
        return {
            org: ('org' in user) ? user.org : {},
        };
    }

OrgProfile.defaultProps = {
    org: {}
}


function mapDispatch(dispatch) {
    return {
        updateOrg: bindActionCreators(updateOrg, dispatch), 
        loadOrg: bindActionCreators(loadOrg, dispatch),
        logout: bindActionCreators(logout, dispatch)
    };
}

export const OrgProfileWithStyles = withStyles(styles)(OrgProfile);
export default connect(select, mapDispatch)(OrgProfileWithStyles);



// WEBPACK FOOTER //
// ./assets/src/js/components/pages/OrgProfile.jsx